/* eslint-disable import/prefer-default-export */
import i18n from 'i18n'

import WidgetType from '../enums/WidgetType'

export const getLabel = (type: unknown) => {
  switch (type) {
    case WidgetType.SOCIAL_WEB_TOPIC_COMPARISON:
    case WidgetType.AUDIENCE_TOPIC_COMPARISON:
      return i18n.t('widgetType.topicComparison')

    case WidgetType.SOCIAL_WEB_SUMMARY_METRICS_COMPACT:
    case WidgetType.AUDIENCE_SUMMARY_METRICS_COMPACT:
      return i18n.t('widgetType.summaryMetricsCompact')

    case WidgetType.SOCIAL_WEB_SENTIMENT:
    case WidgetType.AUDIENCE_SENTIMENT:
      return i18n.t('widgetType.pie')

    case WidgetType.SOCIAL_WEB_DOMAINS:
      return i18n.t('widgetType.bar')

    case WidgetType.SOCIAL_WEB_TIMELINE:
    case WidgetType.SOCIAL_WEB_TIMELINE_OLD:
    case WidgetType.SOCIAL_WEB_TIMELINE_COMPARISON:
    case WidgetType.AUDIENCE_TIMELINE:
    case WidgetType.AUDIENCE_TIMELINE_OLD:
    case WidgetType.AUDIENCE_TIMELINE_COMPARISON:
    case WidgetType.YOUTUBE_TIMELINE:
      return i18n.t('widgetType.timeline')

    case WidgetType.SOCIAL_WEB_WORDCLOUD:
    case WidgetType.SOCIAL_WEB_SENTIMENT_DRIVERS:
    case WidgetType.SOCIAL_WEB_PHOTO_CONCEPTS:
    case WidgetType.AUDIENCE_WORDCLOUD:
    case WidgetType.AUDIENCE_SENTIMENT_DRIVERS:
      return i18n.t('widgetType.wordcloud')

    case WidgetType.SOCIAL_WEB_STREAM:
    case WidgetType.AUDIENCE_STREAM:
    case WidgetType.YOUTUBE_STREAM:
      return i18n.t('widgetType.stream')

    case WidgetType.SOCIAL_WEB_POPULAR_POSTS:
      return i18n.t('widgetType.popularPosts')

    case WidgetType.SOCIAL_WEB_POPULAR_LINKS:
    case WidgetType.AUDIENCE_POPULAR_LINKS:
      return i18n.t('widgetType.topLinks')

    case WidgetType.SOCIAL_WEB_AUTHORS:
    case WidgetType.AUDIENCE_AUTHORS:
      return i18n.t('widgetType.author')

    case WidgetType.IMAGE:
      return i18n.t('widgetType.dashboardImageWidget')

    case WidgetType.SOCIAL_WEB_GEO_REGIONS:
    case WidgetType.AUDIENCE_GEO_REGIONS:
      return i18n.t('widgetType.geographies')

    case WidgetType.SOCIAL_WEB_CROSSTAB:
    case WidgetType.AUDIENCE_CROSSTAB:
      return i18n.t('widgetType.crosstab')

    case WidgetType.AUDIENCE_USAGE_AND_ATTITUDE:
      return i18n.t('widgetType.usageAndAttitudeAnalysis')

    case WidgetType.HEADER:
      return i18n.t('widgetType.dashboardHeaderWidget')

    case WidgetType.TEXT:
      return i18n.t('widgetType.dashboardTextWidget')

    case WidgetType.RICH_TEXT:
      return i18n.t('widgetType.dashboardRichTextWidget')

    case WidgetType.HTML:
      return i18n.t('widgetType.dashboardHtmlWidget')

    case WidgetType.SOCIAL_WEB_BRAND_PASSION_INDEX:
      return i18n.t('widgetType.bubbleWidget')

    case WidgetType.SOCIAL_WEB_SOURCES:
      return i18n.t('widgetType.source')

    case WidgetType.SOCIAL_WEB_INDEX:
    case WidgetType.SOCIAL_WEB_DEMOGRAPHIC:
    case WidgetType.AUDIENCE_INDEX:
    case WidgetType.AUDIENCE_DEMOGRAPHIC:
      return i18n.t('widgetType.benchmark')

    case WidgetType.SOCIAL_WEB_LANGUAGE:
    case WidgetType.AUDIENCE_LANGUAGE:
      return i18n.t('widgetType.language')

    case WidgetType.SOCIAL_WEB_STORY_SCOPE:
      return i18n.t('widgetType.circles')

    case WidgetType.SOCIAL_WEB_TRENDING:
    case WidgetType.AUDIENCE_TRENDING:
      return i18n.t('widgetType.trending')

    case WidgetType.SOCIAL_WEB_POPULAR_MEDIA:
    case WidgetType.AUDIENCE_POPULAR_MEDIA:
      return i18n.t('widgetType.mediaAnalysis')

    case WidgetType.SOCIAL_WEB_SUMMARY_METRICS:
    case WidgetType.AUDIENCE_SUMMARY_METRICS:
    case WidgetType.YOUTUBE_SUMMARY_METRICS:
      return i18n.t('widgetType.metricGrid')

    case WidgetType.SOCIAL_WEB_DAY_AND_HOUR:
    case WidgetType.AUDIENCE_DAY_AND_HOUR:
      return i18n.t('widgetType.dayAndHour')

    case WidgetType.GEO_TAGGED:
      return i18n.t('widgetType.goetagAnalysis')

    case WidgetType.SOCIAL_WEB_TAGS:
      return i18n.t('widgetType.tagAnalysis')

    case WidgetType.SOCIAL_WEB_CHANNELS:
      return i18n.t('widgetType.channelComparison')

    case WidgetType.SOCIAL_WEB_SIDE_BY_SIDE:
      return i18n.t('widgetType.sideBySideAnalysis')

    default:
      return ''
  }
}
